const styles = {
    tableHeaderColumnCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        padding: '0 5px',
    },
    tableRowColumnCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '20%',
        padding: '0 5px',
    },
    tableRowColumnBigCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '500px',
        width: '30%',
        padding: '0 5px',
    },
    tableHeaderColumnSmallCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '100px',
        padding: '0 5px',
    },
    tableRowColumnSmallCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '100px',
        padding: '0 5px',
    },
    tableRowColumnModified: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '150px',
        padding: '0 5px',
    },
    tableRowColumnModifed: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '150px',
        padding: '0 5px',
    },
    fullHeightFlexContainer: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    greenBtn: { background: '#27ae60', color: '#fff' },
    tableRowBordered: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '100px',
        padding: '15px 15px 15px 15px',
        borderLeft: '1px solid rgb(224, 224, 224)',
        borderRight: '1px solid rgb(224, 224, 224)',
    },
    tableRowBorderedTop: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '100px',
        padding: '15px 15px 15px 15px',
        borderLeft: '1px solid rgb(224, 224, 224)',
        borderRight: '1px solid rgb(224, 224, 224)',
        borderTop: '1px solid rgb(224, 224, 224',
    },
    nestedRowColumn: {
        flex: '1',
        height: '100%',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        padding: '15px 15px 15px 15px',
        maxWidth: '200px',
    },
    selectFieldCSS: {
        padding: '0 5px',
        width: '90%',
        fontSize: '13px',
    },
    textLabel: {
        marginBottom: '-14px',
        color: 'rgb(158, 158, 158)',
    },
    menuItemCSS: {
        width: 'auto',
        fontSize: '13px',
    },
    autoCompleteCSS: {
        fontSize: '13px',
    },
    circularProgress: {
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    headline: {
        fontSize: 24,
        paddingTop: 16,
        marginBottom: 12,
        fontWeight: 400,
    },
    RaisedButton: {
        margin: '0 0 0 20px',
    },
    importVesselsBtn: {
        margin: '0 0 0 20px',
    },
    autoCompleteListStyle: {
        overflow: 'auto',
        maxHeight: '300px',
    },
    textField: {
        fontSize: '13px',
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer',
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)',
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer',
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)',
    },
    btnOrders: {
        minWidth: '25%',
        color: '#fff',
    },
    btnNewOrders: {
        minWidth: '25%',
        color: '#fff',
    },
    approvedBtn: {
        backgroundColor: 'rgb(164, 198, 57)',
        color: '#fff',
    },
    dangerText: {
        color: '#f44336',
    },

    autoHeightContainer: {
        height: 'auto',
    },

    autoHeightButton: {
        padding: '10px 0px',
    },
};

export default styles;



// WEBPACK FOOTER //
// ./app/styles/index.js